// Fires events to whichever pixels the admin has configured. No-ops if absent.
export function track(event, params = {}) {
  try {
    if (window.gtag) window.gtag("event", event, params);
    if (window.fbq) {
      const fbMap = { Purchase: "Purchase", BeginCheckout: "InitiateCheckout", Register: "CompleteRegistration", Lead: "Lead", Contact: "Contact", ViewService: "ViewContent" };
      window.fbq("track", fbMap[event] || event, params);
    }
    if (window.ttq) {
      const ttMap = { Purchase: "CompletePayment", BeginCheckout: "InitiateCheckout", Register: "CompleteRegistration", ViewService: "ViewContent", Contact: "Contact", Lead: "SubmitForm" };
      window.ttq.track(ttMap[event] || event, params);
    }
  } catch (e) { /* tracking must never break the app */ }
}
